import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "row mt-4" };
const _hoisted_3 = { class: "col-lg-12" };
const _hoisted_4 = { class: "card" };
const _hoisted_5 = { class: "card-body" };
import NomenclatureTypeCreate from "@/binaplan/components/admin/nomenclature/TypeCreateContainer.vue";
import TitlePage from "@/binaplan/components/layouts/TitlePageContainer.vue";
import Lang from "@/plugins/Lang";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TypeCreateView',
    setup(__props) {
        const lang = {
            title: Lang.get("admin-nomenclature.type_title_add"),
            btn_back: Lang.get("admin-nomenclature.type_button_back"),
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(TitlePage, {
                        "back-button": lang.btn_back,
                        "back-url": "/admin/nomenclature/types",
                        "title-page": lang.title
                    }, null, 8, ["back-button", "title-page"])
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(NomenclatureTypeCreate)
                            ])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
